/* eslint-disable unicorn/better-regex, unicorn/prefer-ternary */
import React from 'react'

import Lightbox from '../../chat/components/Lightbox'
import styles from './Attachments.module.scss'

interface AttachmentData {
  name: string
  urls: {
    thumbnail?: string
    original: string
  }
  type: 'image' | 'file' | 'video'
}

export default function Attachments({ content }: { content: string }) {
  const [lightboxSrc, setLightboxSrc] = React.useState<{ url: string; type: 'image' | 'video' } | null>(null)

  const attachments = React.useMemo<AttachmentData[]>(() => {
    try {
      const trimmedContent = content.trim()
      const validJson = trimmedContent
        .replace(/^{'/g, '{"')
        .replace(/'}/g, '"}')
        .replace(/':\s*'/g, '": "')
        .replace(/',\s*'/g, '", "')
        .replace(/:\s*\[/g, ': [')
        .replace(/\]\s*}/g, ']}')

      const parsed = JSON.parse(validJson) as AttachmentData[]
      return Array.isArray(parsed) ? parsed : []
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to parse attachments:', error)
      return []
    }
  }, [content])

  if (attachments.length === 0) {
    return null
  }

  return (
    <>
      <div className={styles.Attachments}>
        {attachments.map((attachment, index) => {
          if (attachment.type === 'image') {
            return (
              <div
                key={index}
                className={styles.Attachments__image}
                onClick={() => setLightboxSrc({ url: attachment.urls.original, type: 'image' })}
                title={attachment.name}
              >
                <img
                  src={attachment.urls.thumbnail || attachment.urls.original}
                  alt={attachment.name}
                  className={styles.Attachments__imageThumbnail}
                />
                <div className={styles.Attachments__imageOverlay}>
                  <i className="icon-aytmfd-zoom-in" />
                </div>
              </div>
            )
          } else if (attachment.type === 'video') {
            return (
              <div
                key={index}
                className={styles.Attachments__video}
                onClick={() => setLightboxSrc({ url: attachment.urls.original, type: 'video' })}
                title={attachment.name}
              >
                <video
                  src={attachment.urls.thumbnail || attachment.urls.original}
                  className={styles.Attachments__videoThumbnail}
                  muted
                />
                <div className={styles.Attachments__videoOverlay}>
                  <i className="pi pi-play" />
                </div>
              </div>
            )
          } else {
            return (
              <a
                key={index}
                href={attachment.urls.original}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.Attachments__file}
                title={attachment.name}
              >
                <i className="pi pi-paperclip" />
                <span className={styles.Attachments__fileName}>{attachment.name}</span>
              </a>
            )
          }
        })}
      </div>

      {lightboxSrc && <Lightbox url={lightboxSrc.url} type={lightboxSrc.type} onClose={() => setLightboxSrc(null)} />}
    </>
  )
}
